import { render } from "./ParamTransportChannelPageList.vue?vue&type=template&id=91b8912c&scoped=true&ts=true"
import script from "./ParamTransportChannelPageList.vue?vue&type=script&lang=ts"
export * from "./ParamTransportChannelPageList.vue?vue&type=script&lang=ts"

import "./ParamTransportChannelPageList.vue?vue&type=style&index=0&id=91b8912c&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91b8912c"]])

export default __exports__